const submitButton = document.querySelector(".product-form__submit");

console.log("submitButton", submitButton);

submitButton?.addEventListener("click", function (event) {
  if (MOQ != "") {
    const quantitySelected = Number(document.querySelector(".quantity__input").value);
    if (quantitySelected < MOQ) {
      event.preventDefault();
      document.querySelector("#cart-errors").innerHTML = `Order minimum Quantity is ${MOQ}`;
    }
  }
});
